import axios from 'axios';
import { settings } from '../config';
const tg = window?.Telegram?.WebApp;
const initData = tg?.initData;

export async function getBoxes() {
  const encodedInitData = encodeURIComponent(initData || '');
  const config = {
    headers: {
      Authorization: `Bearer ${encodedInitData}`,
    },
  };
  try {
    const url = `${settings.url}boxes`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function getBox(id: number) {
  const encodedInitData = encodeURIComponent(initData || '');
  const config = {
    headers: {
      Authorization: `Bearer ${encodedInitData}`,
    },
  };
  try {
    const url = `${settings.url}boxes/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function openBox(id: number) {
  const encodedInitData = encodeURIComponent(initData || '');
  const config = {
    headers: {
      Authorization: `Bearer ${encodedInitData}`,
    },
  };
  try {
    const url = `${settings.url}boxes/${id}/spin`;
    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
